/**
 * Lechia Variant
 */
 let LechiaVariant = {
    /**
     * Whether the variant has metafields
     * @param {*} variant 
     * @returns 
     */
    hasMetafields(variant) {
        return !_.isEmpty(variant.metafields);
    },

    /**
     * 
     * @param {*} variant 
     * @returns {Boolean}
     */
    isHidden(variant) {
        if (!this.hasMetafields(variant)) {
            return false;
        }
        if (variant.metafields.variantHidden === 'true') {
            return true;
        }
        return false;
    },

    /**
     * Whether variant is unavailable
     * @param {*} variant 
     * @returns {Boolean} 
     */
    isUnavailable(variant) {
        return !!variant.available;
    }

};